import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CodesUseCases } from './codes.use-cases.contract';

import { CODES_REPOSITORY, CodesRepository } from '@/domain/repositories/codes/codes.repository.contract';
import { IosInstallCode } from '@/models/codes/codes.model';

@Injectable({
  providedIn: 'root'
})
export class CodesUseCasesImpl implements CodesUseCases {
  #codesRepository: CodesRepository = inject(CODES_REPOSITORY);

  getAppUrl(store: string): Observable<IosInstallCode> {
    return this.#codesRepository.getAppUrl(store);
  }
}
